import { render, staticRenderFns } from "./PopupIndexApprovalNotes.vue?vue&type=template&id=1d506141&"
import script from "./PopupIndexApprovalNotes.vue?vue&type=script&lang=js&"
export * from "./PopupIndexApprovalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports